export { default as listCompanyVehicleClassSlice } from './listCompanyVehicleClassSlice'
